import React from 'react';
import Skeleton from '@smart-tv/components/skeleton';
import { PROGRAM_HEIGHT } from '../utils/tv-guide-helpers';
import styles from './tv-guide.module.scss';

export const TvGuideSkeletonGrid: React.FC = () => {
  const channels = [...Array(7)];

  return (
    <div className={styles['tv-guide-skeleton-grid']}>
      <div className={styles['tv-guide-skeleton-grid__channels']}>
        {channels.map((_, index) => (
          <Skeleton
            key={index}
            className={styles['tv-guide-skeleton-grid__row']}
            
            variant="rect"
          />
        ))}
      </div>
      <div className={styles['tv-guide-skeleton-grid__programs']}>
        {channels.map((_, index) => (
          <Skeleton
            key={index}
            className={styles['tv-guide-skeleton-grid__row']}
            
            variant="rect"
          />
        ))}
      </div>
    </div>
  );
};

export const TvGuideSkeleton: React.FC = () => {
  const buttons = [...Array(3)];

  return (
    <div>
      <div className={styles['tv-guide-skeleton-info']}>
        <Skeleton width="40%" className={styles['tv-guide-skeleton-info__title']} />
        <Skeleton width="30%" className={styles['tv-guide-skeleton-info__subtitle']} />
        <Skeleton width="20%" className={styles['tv-guide-skeleton-info__duration']} />
        <div className={styles['tv-guide-skeleton-info__buttons']}>
          {buttons.map((_, index) => (
            <Skeleton
              key={index}
              className={styles['tv-guide-skeleton-info__button']}
              width="100%"
              variant="rect"
            />
          ))}
        </div>
      </div>
      <TvGuideSkeletonGrid />
    </div>
  );
};

export default TvGuideSkeleton;
